/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'link': {
    width: 26,
    height: 25,
    viewBox: '0 0 26 25',
    data: '<path pid="0" d="M10.143 13.269a5.298 5.298 0 007.99.572l3.179-3.18A5.299 5.299 0 0013.82 3.17l-1.822 1.812" _stroke="#768692" stroke-width="2.343" stroke-linecap="round" stroke-linejoin="round"/><path pid="1" d="M14.382 11.15a5.299 5.299 0 00-7.99-.573l-3.178 3.18a5.3 5.3 0 007.491 7.492l1.812-1.812" _stroke="#768692" stroke-width="2.343" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
